// @flow

import React, { Fragment } from "react";
import className from "classnames";
import { Column } from "../column";
import type { ColumnType } from "../../types";

type Props = {|
  rows: ColumnType[],
|};

export const SubRows = (props: Props) => (
  <Fragment>
    {props.rows.map((subRow, index) => (
      <div key={`subrow-${index}`} className={className({ "pt-3": index !== 0 })}>
        <Column column={subRow} />
      </div>
    ))}
  </Fragment>
);

export default SubRows;
